import React from 'react';
import jsPDF from 'jspdf';
import { X, Download, Share } from 'lucide-react';

const InvoiceGenerator = ({ sale, onClose }) => {
  const [companyDetails, setCompanyDetails] = React.useState({
    name: 'ADDICT',
    address: '123 Business Street',
    city: 'Colombo, Sri Lanka',
    phone: '+94 11 234 5678',
    email: 'info@addict.lk'
  });

  React.useEffect(() => {
    const storedCompany = localStorage.getItem('addictCompany');
    if (storedCompany) {
      setCompanyDetails(JSON.parse(storedCompany));
    }
  }, []);
  const generatePDF = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    const margin = 20;
    let yPos = 15;
    
    // Load logo with promise-based approach
    try {
      const logoDataURL = await new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        
        img.onload = function() {
          canvas.width = this.width;
          canvas.height = this.height;
          ctx.drawImage(this, 0, 0);
          resolve(canvas.toDataURL('image/jpeg', 0.8));
        };
        
        img.onerror = function() {
          const img2 = new Image();
          img2.onload = function() {
            canvas.width = this.width;
            canvas.height = this.height;
            ctx.drawImage(this, 0, 0);
            resolve(canvas.toDataURL('image/jpeg', 0.8));
          };
          img2.onerror = () => resolve(null);
          img2.src = '/logo.jpg';
        };
        
        img.src = '/logo.jpeg';
      });
      
      if (logoDataURL) {
        pdf.addImage(logoDataURL, 'JPEG', pageWidth - 75, 20, 50, 30);
      }
    } catch (error) {
      console.log('Logo loading failed:', error);
    }
    
    // Company header with dynamic name from settings
    pdf.setTextColor(40, 40, 40);
    pdf.setFontSize(36);
    pdf.setFont('helvetica', 'bold');
    pdf.text(companyDetails.name, margin, yPos + 18);
    
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'italic');
    pdf.setTextColor(100, 100, 100);
    pdf.text('its more than an addiction', margin, yPos + 25);
    
    // Company details from settings
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    pdf.text(`${companyDetails.address}, ${companyDetails.city}`, margin, yPos + 33);
    pdf.text(`${companyDetails.phone} | ${companyDetails.email}`, margin, yPos + 38);
    
    // Clean separator
    pdf.setDrawColor(180, 180, 180);
    pdf.setLineWidth(0.3);
    pdf.line(margin, yPos + 42, pageWidth - margin, yPos + 42);
    
    yPos = 65;
    
    // Invoice title
    pdf.setTextColor(40, 40, 40);
    pdf.setFontSize(20);
    pdf.setFont('helvetica', 'bold');
    pdf.text('INVOICE', margin, yPos);
    
    yPos += 15;
    
    // Invoice details - clean layout
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(60, 60, 60);
    
    pdf.text('Invoice Number:', margin, yPos);
    pdf.setFont('helvetica', 'bold');
    pdf.text(invoiceNumber, margin + 35, yPos);
    
    pdf.setFont('helvetica', 'normal');
    pdf.text('Date:', margin + 80, yPos);
    pdf.setFont('helvetica', 'bold');
    pdf.text(invoiceDate, margin + 95, yPos);
    
    yPos += 8;
    pdf.setFont('helvetica', 'normal');
    pdf.text('Customer:', margin, yPos);
    pdf.setFont('helvetica', 'bold');
    pdf.text(sale.customerName, margin + 25, yPos);
    
    // Payment status
    pdf.setFont('helvetica', 'normal');
    pdf.text('Payment Status:', margin + 80, yPos);
    const paymentStatusText = (sale.paymentStatus || 'not_paid').replace('_', ' ').toUpperCase();
    if (sale.paymentStatus === 'full_paid') {
      pdf.setTextColor(0, 120, 0);
    } else if (sale.paymentStatus === 'half_paid') {
      pdf.setTextColor(200, 100, 0);
    } else {
      pdf.setTextColor(180, 0, 0);
    }
    pdf.setFont('helvetica', 'bold');
    pdf.text(paymentStatusText, margin + 110, yPos);
    
    yPos += 20;
    
    // Clean table header
    pdf.setFillColor(245, 245, 245);
    pdf.rect(margin, yPos, pageWidth - 2 * margin, 8, 'F');
    
    pdf.setTextColor(60, 60, 60);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(9);
    pdf.text('DESCRIPTION', margin + 3, yPos + 5);
    pdf.text('QTY', margin + 90, yPos + 5);
    pdf.text('UNIT PRICE', margin + 115, yPos + 5);
    pdf.text('TOTAL', margin + 150, yPos + 5);
    
    yPos += 12;
    
    // Items
    pdf.setTextColor(70, 70, 70);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9);
    
    let subtotal = 0;
    (sale.items || []).forEach((item, index) => {
      const itemTotal = (item.pricePerPair || item.price || 0) * (item.quantity || 0);
      subtotal += itemTotal;
      
      // Alternating background
      if (index % 2 === 1) {
        pdf.setFillColor(252, 252, 252);
        pdf.rect(margin, yPos - 2, pageWidth - 2 * margin, 10, 'F');
      }
      
      pdf.setFont('helvetica', 'bold');
      pdf.text(item.articleNumber || '', margin + 3, yPos + 2);
      pdf.setFont('helvetica', 'normal');
      pdf.text(item.colour || '', margin + 3, yPos + 6);
      pdf.text(`${item.quantity || 0} pairs`, margin + 90, yPos + 4);
      pdf.text(`LKR ${(item.pricePerPair || item.price || 0).toLocaleString()}`, margin + 115, yPos + 4);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`LKR ${itemTotal.toLocaleString()}`, margin + 150, yPos + 4);
      
      yPos += 12;
    });
    
    yPos += 10;
    
    // Clean totals section
    pdf.setDrawColor(200, 200, 200);
    pdf.line(margin + 100, yPos, pageWidth - margin, yPos);
    yPos += 8;
    
    pdf.setTextColor(60, 60, 60);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10);
    pdf.text('Subtotal:', margin + 115, yPos);
    pdf.text(`LKR ${subtotal.toLocaleString()}`, margin + 150, yPos);
    
    if (sale.discount && sale.discount > 0) {
      yPos += 6;
      pdf.setTextColor(180, 0, 0);
      pdf.text(`Discount (${sale.discount}%):`, margin + 115, yPos);
      pdf.text(`-LKR ${(subtotal * sale.discount / 100).toLocaleString()}`, margin + 150, yPos);
    }
    
    yPos += 8;
    pdf.setDrawColor(60, 60, 60);
    pdf.setLineWidth(0.5);
    pdf.line(margin + 100, yPos, pageWidth - margin, yPos);
    yPos += 8;
    
    // Total
    pdf.setTextColor(40, 40, 40);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(12);
    pdf.text('TOTAL:', margin + 115, yPos);
    pdf.text(`LKR ${total.toLocaleString()}`, margin + 150, yPos);
    
    yPos += 15;
    
    // Payment status summary
    pdf.setFontSize(10);
    if (sale.paymentStatus === 'full_paid') {
      pdf.setTextColor(0, 120, 0);
      pdf.text('FULLY PAID', margin + 115, yPos);
    } else if (sale.paymentStatus === 'half_paid') {
      pdf.setTextColor(200, 100, 0);
      pdf.text('PARTIALLY PAID', margin + 115, yPos);
      const paidAmount = sale.paidAmount || 0;
      const remaining = total - paidAmount;
      yPos += 6;
      pdf.setTextColor(70, 70, 70);
      pdf.setFontSize(9);
      pdf.text(`Paid: LKR ${paidAmount.toLocaleString()}`, margin + 115, yPos);
      yPos += 5;
      pdf.setTextColor(180, 0, 0);
      pdf.text(`Balance: LKR ${remaining.toLocaleString()}`, margin + 115, yPos);
    } else {
      pdf.setTextColor(180, 0, 0);
      pdf.text('PAYMENT PENDING', margin + 115, yPos);
      yPos += 6;
      pdf.setTextColor(70, 70, 70);
      pdf.setFontSize(9);
      pdf.text(`Amount Due: LKR ${total.toLocaleString()}`, margin + 115, yPos);
    }
    
    // Clean footer
    yPos += 25;
    pdf.setDrawColor(200, 200, 200);
    pdf.setLineWidth(0.3);
    pdf.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 8;
    
    pdf.setTextColor(120, 120, 120);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(7);
    pdf.text(`Generated: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`, margin, yPos);
    pdf.text(`Thank you for your business with ${companyDetails.name}!`, margin, yPos + 5);
    
    return pdf;
  };

  const downloadPDF = async () => {
    const pdf = await generatePDF();
    pdf.save(`Invoice_${invoiceNumber}.pdf`);
  };

  const shareWhatsApp = async () => {
    const pdf = await generatePDF();
    const pdfBlob = pdf.output('blob');
    
    const url = URL.createObjectURL(pdfBlob);
    const message = `Invoice #${invoiceNumber}\\nCustomer: ${sale.customerName}\\nTotal: LKR ${total.toLocaleString()}\\nPayment Status: ${(sale.paymentStatus || 'not_paid').replace('_', ' ').toUpperCase()}`;
    const whatsappUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, '_blank');
    
    setTimeout(() => {
      const link = document.createElement('a');
      link.href = url;
      link.download = `Invoice_${invoiceNumber}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    }, 1000);
  };

  const invoiceNumber = String(sale.id).slice(-6).padStart(6, '0');
  const invoiceDate = new Date(sale.createdAt).toLocaleDateString();
  const total = sale.totalAmount || sale.total || 0;

  return (
    <div className="invoice-modal-overlay">
      <div style={{
        background: 'white',
        borderRadius: window.innerWidth < 768 ? '0' : '16px',
        width: window.innerWidth < 768 ? '100vw' : '95%',
        maxWidth: window.innerWidth < 768 ? '100vw' : '800px',
        maxHeight: window.innerWidth < 768 ? '100vh' : '95vh',
        overflow: 'hidden',
        boxShadow: window.innerWidth < 768 ? 'none' : '0 20px 60px rgba(0,0,0,0.3)',
        margin: window.innerWidth < 768 ? '0' : '10px'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: window.innerWidth < 768 ? '16px' : '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '10px'
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: window.innerWidth < 768 ? '1.2rem' : '1.5rem', fontWeight: '600' }}>Invoice #{invoiceNumber}</h2>
            <p style={{ margin: '4px 0 0 0', opacity: 0.9, fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem' }}>{sale.customerName}</p>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            borderRadius: '8px',
            padding: '8px',
            color: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: window.innerWidth < 768 ? '12px' : '32px', overflowY: 'auto', maxHeight: window.innerWidth < 768 ? 'calc(100vh - 160px)' : 'calc(95vh - 200px)' }}>
          {/* Invoice Info */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth < 480 ? '1fr' : window.innerWidth < 768 ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: window.innerWidth < 768 ? '10px' : '16px',
            marginBottom: window.innerWidth < 768 ? '16px' : '24px',
            padding: window.innerWidth < 768 ? '12px' : '16px',
            background: '#f8f9fa',
            borderRadius: '8px'
          }}>
            <div>
              <h4 style={{ margin: '0 0 6px 0', color: '#667eea', fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem', fontWeight: '600' }}>INVOICE NUMBER</h4>
              <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '1rem' : '1.1rem', fontWeight: '600' }}>#{invoiceNumber}</p>
            </div>
            <div>
              <h4 style={{ margin: '0 0 6px 0', color: '#667eea', fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem', fontWeight: '600' }}>DATE</h4>
              <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '1rem' : '1.1rem' }}>{invoiceDate}</p>
            </div>
            <div>
              <h4 style={{ margin: '0 0 6px 0', color: '#667eea', fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem', fontWeight: '600' }}>CUSTOMER</h4>
              <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '1rem' : '1.1rem' }}>{sale.customerName}</p>
            </div>
            <div>
              <h4 style={{ margin: '0 0 6px 0', color: '#667eea', fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem', fontWeight: '600' }}>PAYMENT STATUS</h4>
              <span style={{
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: window.innerWidth < 768 ? '0.75rem' : '0.85rem',
                fontWeight: '600',
                background: sale.paymentStatus === 'full_paid' ? '#d4edda' : sale.paymentStatus === 'half_paid' ? '#fff3cd' : '#f8d7da',
                color: sale.paymentStatus === 'full_paid' ? '#155724' : sale.paymentStatus === 'half_paid' ? '#856404' : '#721c24'
              }}>
                {(sale.paymentStatus || 'not_paid').replace('_', ' ').toUpperCase()}
              </span>
            </div>
          </div>

          {/* Items Table */}
          <div style={{ marginBottom: window.innerWidth < 768 ? '16px' : '24px' }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: window.innerWidth < 768 ? '1.1rem' : '1.2rem' }}>Items</h3>
            <div style={{
              border: '1px solid #e9ecef',
              borderRadius: '12px',
              overflow: 'hidden'
            }}>
              {window.innerWidth >= 768 ? (
                <>
                  <div style={{
                    background: '#f8f9fa',
                    padding: '16px',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr',
                    gap: '16px',
                    fontWeight: '600',
                    fontSize: '0.9rem',
                    color: '#666'
                  }}>
                    <div>ITEM</div>
                    <div style={{ textAlign: 'center' }}>QTY</div>
                    <div style={{ textAlign: 'center' }}>PRICE</div>
                    <div style={{ textAlign: 'right' }}>TOTAL</div>
                  </div>
                  {(sale.items || []).map((item, index) => (
                    <div key={index} style={{
                      padding: '16px',
                      display: 'grid',
                      gridTemplateColumns: '2fr 1fr 1fr 1fr',
                      gap: '16px',
                      borderTop: index > 0 ? '1px solid #f1f3f4' : 'none',
                      alignItems: 'center'
                    }}>
                      <div>
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                          ({item.articleNumber}) {item.colour}
                        </div>
                      </div>
                      <div style={{ textAlign: 'center', fontWeight: '600' }}>
                        {item.quantity} pairs
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        LKR {(item.pricePerPair || item.price || 0).toLocaleString()}
                      </div>
                      <div style={{ textAlign: 'right', fontWeight: '600' }}>
                        LKR {((item.pricePerPair || item.price || 0) * (item.quantity || 0)).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                // Mobile layout - stacked cards
                (sale.items || []).map((item, index) => (
                  <div key={index} style={{
                    padding: '16px',
                    borderTop: index > 0 ? '1px solid #f1f3f4' : 'none'
                  }}>
                    <div style={{ fontWeight: '600', marginBottom: '8px', fontSize: '1.1rem' }}>
                      ({item.articleNumber}) {item.colour}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                      <span>Quantity:</span>
                      <span style={{ fontWeight: '600' }}>{item.quantity} pairs</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                      <span>Price per pair:</span>
                      <span>LKR {(item.pricePerPair || item.price || 0).toLocaleString()}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid #f1f3f4' }}>
                      <span style={{ fontWeight: '600' }}>Total:</span>
                      <span style={{ fontWeight: '600', color: '#667eea' }}>LKR {((item.pricePerPair || item.price || 0) * (item.quantity || 0)).toLocaleString()}</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Total */}
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: window.innerWidth < 768 ? '20px' : '24px',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '1.1rem', opacity: 0.9 }}>TOTAL AMOUNT</h3>
            <div style={{ fontSize: window.innerWidth < 768 ? '1.5rem' : '2rem', fontWeight: 'bold' }}>
              LKR {total.toLocaleString()}
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div style={{
          padding: window.innerWidth < 768 ? '16px' : '24px',
          borderTop: '1px solid #e9ecef',
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button onClick={downloadPDF} style={{
            background: '#667eea',
            color: 'white',
            border: 'none',
            padding: window.innerWidth < 768 ? '10px 20px' : '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: '600',
            fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem'
          }}>
            <Download size={16} /> Download PDF
          </button>
          <button onClick={shareWhatsApp} style={{
            background: '#25D366',
            color: 'white',
            border: 'none',
            padding: window.innerWidth < 768 ? '10px 20px' : '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: '600',
            fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem'
          }}>
            <Share size={16} /> Share WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceGenerator;